import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Box, IconButton, Tooltip } from "@mui/material";
import { createMRTColumnHelper } from "material-react-table";
import { toast } from "react-toastify";
import { ContentCopy } from "@mui/icons-material";
import CustomTable from "../../components/customTable/CustomTable";
import {
  partnerProposal,
  partnerSipList,
} from "../../app/slices/partnerInvoice/partnerTransactionSlice";

export default function Sip({ id }) {
  // console.log("Proposal Component Rendered", partnerUserID);
  const dispatch = useDispatch();

  const [proposals, setProposals] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!id) return;
    // console.log("helooo>>>>>>>>>>>>");
    const fetchProposals = async () => {
      setLoading(true);

      try {
        const response = await dispatch(
          partnerSipList({
            partner_id: id,
          }),
        );

        // console.log(response, "hloooo>>>>>>>>>>>>>>.");

        if (response.meta.requestStatus === "fulfilled") {
          setProposals(response.payload.data || []);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchProposals();
  }, [id, dispatch]);
  const sliceResponse =
    proposals.length > 0 &&
    proposals?.map((item) => ({
      id: item?._id || "-",
      Blockid: item?.Blockid || "-",
      payment_link: item?.payment_link || "-",
      frequency: item?.frequency || "-",
      day_of_month: item?.day_of_month || "-",
      sip_purpose: item?.sip_purpose || "-",
      proposalNo: item?.proposal_no || "-",
      proposal_type: item?.proposal_type || "-",
      source: item?.source || "Mobile",
      name: item?.customerRefNo?.name || "-",
      _id: item?.customerRefNo?._id || "-",
      mobileNo: item?.customerRefNo?.phone || "-",
      partnerId: item?.partner_id || "-",
      amount: item?.amount || "-",
      quantity: item?.quantity || "-",
      refinery: item?.refinery || "-",
      metalType: item?.metal_type || "-",
      Price: item?.Price || "-",
      subReferenceId: item?.subReferenceId || "-",
      status: item?.status || "-",
      createdAt: item?.createdAt || "-",
      updatedAt: item?.updatedAt || "-",
    }));

  const makeCopyableColumn = (columnHelper, accessorKey, header, size = 30) =>
    columnHelper.accessor(accessorKey, {
      header,
      size,
      Cell: ({ cell }) => {
        const value = cell.row.original[accessorKey];
        const handleCopy = () => {
          navigator.clipboard.writeText(value ?? "");
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={value || "N/A"}>
            <span>
              <IconButton onClick={handleCopy} size="small">
                <ContentCopy fontSize="inherit" />
              </IconButton>
              {value}
            </span>
          </Tooltip>
        );
      },
    });

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("name", { header: "Name", size: 30 }),
    columnHelper.accessor("mobileNo", { header: "Mobile No", size: 30 }),
    columnHelper.accessor("metalType", { header: "Metal Type", size: 30 }),
    columnHelper.accessor("amount", { header: "Amount", size: 30 }),
    columnHelper.accessor("frequency", { header: "Frequency", size: 30 }),
    columnHelper.accessor("day_of_month", { header: "Day", size: 30 }),
    columnHelper.accessor("status", { header: "Status", size: 30 }),
    columnHelper.accessor("source", { header: "Source", size: 30 }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: ({ cell }) => cell?.row?.original?.createdAt?.split("T")[0],
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: ({ cell }) => cell?.row?.original?.updatedAt?.split("T")[0],
    }),
    columnHelper.accessor("proposalNo", { header: "Proposal No", size: 30 }),
    columnHelper.accessor("subReferenceId", {
      header: "SubReferenceId",
      size: 30,
    }),
  ];

  return (
    <Box mt={2}>
      <CustomTable
        columns={columns}
        data={sliceResponse}
        loading={loading}
        permissionKey="PartnerSip"
      />
    </Box>
  );
}
